import React, { lazy, Suspense, memo } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { ConfigProvider } from 'antd';
import { useLocation } from 'react-router-dom';
import Loading from 'components/shared-components/Loading';
import { lightTheme, darkTheme } from 'configs/ThemeConfig';
import { resources } from 'lang';
import useBodyClass from 'utils/hooks/useBodyClass';
import Routes from 'routes'
import { getMe } from 'store/slices/authSlice';
import { useEffect } from 'react';
const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

const Layouts = () => {
	const dispatch = useDispatch();
	const token = useSelector(state => state.auth.token);
	const me = useSelector(state => state.auth.me);

	useEffect(() => {
		if (token && !me) {
			dispatch(getMe());
		}
	}, [token, me, dispatch]);

	const blankLayout = useSelector(state => state.theme.blankLayout);
	const { pathname } = useLocation();

	// La consent de OAuth (conectar Claude) se abre en una ventana del browser
	// lanzada por el cliente MCP: va sin el chrome del panel aunque haya sesión.
	const sinChrome = blankLayout || pathname.startsWith('/oauth/');

	const Layout = token && !sinChrome ? AppLayout : AuthLayout;

	const locale = useSelector(state => state.theme.locale);

	const direction = useSelector(state => state.theme.direction);

	const currentTheme = useSelector(state => state.theme.currentTheme);

	const currentAppLocale = resources[locale];

	useBodyClass(`dir-${direction}`);

	const themeConfig = currentTheme === 'light' ? { ...lightTheme } : { ...darkTheme }

	return (
		<ConfigProvider theme={themeConfig} direction={direction} locale={currentAppLocale.antd}>
			<Suspense fallback={<Loading cover="content" />}>
				<Layout>
					<Routes />
				</Layout>
			</Suspense>
		</ConfigProvider>
	)
}


export default memo(Layouts)